import React from "react";

import ortLogo from "../assets/images/support/ort-cie-logo.png";
import nvidiaLogo from "../assets/images/support/NVIDIA-logo.png";
import microsoft from "../assets/images/support/microsoft.png";
import circularLogo from "../assets/images/support/circular-logo.png";
import practiaLogo from "../assets/images/support/practia-logo.png";
import hexaLogo from "../assets/images/support/hexa-ingenieria-logo.png";
import { useTranslation } from "react-i18next";

export default function Supporters() {
  const { t } = useTranslation();

  const supporter = [
    { id: "1", link: "https://cie.ort.edu.uy/emprendimientos/analabs", imageSrc: ortLogo, name: "ORT" },
    { id: "2", link: "https://www.microsoft.com/", imageSrc: microsoft, name: "Microsoft" },
    { id: "3", link: "https://www.nvidia.com/en-us/", imageSrc: nvidiaLogo, name: "NVIDIA" },
    { id: "4", link: "https://circular.com.uy/", imageSrc: circularLogo, name: "Circular" },
    { id: "5", link: "https://practia.uy/", imageSrc: practiaLogo, name: "Practia Uruguay" },
    { id: "6", link: "https://hexa-ingenieria.com/", imageSrc: hexaLogo, name: "Hexa Ingenieria" },
  ];

  return (
    <section className="py-12 border-b border-gray-100" id="support">
      <div className="container">
        <p
          className="text-center text-sm font-semibold uppercase tracking-widest mb-8"
          style={{ color: '#9ca3af', fontFamily: '"Inter", sans-serif' }}
        >
          {t("Support.subtitle")}
        </p>
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
          {supporter.map(({ id, name, link, imageSrc }) => (
            <a
              key={id}
              href={link}
              target="_blank"
              rel="noreferrer"
              className="block grayscale hover:grayscale-0 opacity-50 hover:opacity-80 transition-all duration-300"
            >
              <img alt={`${name} - ANA Labs partner`} src={imageSrc} className="max-h-[48px] max-w-[140px] object-contain" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
